<template>
    <div class="input-over-10w">
        <el-input-number
            v-model="model"
            controls-position="right"
            :min="0"
            style="width:250px"
            @change="changeHandler"
        ></el-input-number>

        <font class="color-warning">万</font>人民币
    </div>
</template>

<script>
import model from '@mixins/model'
import lessVars from '@/css/var.scss'

export default {
    mixins: [ model ],
    props: {
        value: {
            type: [String, Number],
            default: 0
        },
        label: {
            type: String,
            default: '值'
        }
    },
    data () {
        return {

        }
    },
    methods: {
        changeHandler(event) {
            if(Number(event) >= 100000) {
                this.$confirm(`
                您输入的${this.label}为：
                    <font style="color:${lessVars.warningColor}; font-weight:bold;">
                        ${event} 万人民币
                    </font>
                ，请确认是否正确`, '提示', {
                    confirmButtonText: `确定，${event}万人民币`,
                    cancelButtonText: `否定，改为${event / 10000}万人民币`,
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                    showClose: false,
                    closeOnPressEscape: false,
                    closeOnClickModal: false
                }).then(() => {
                    
                }).catch(() => {
                    this.model = event / 10000;        
                });
            }
        }
    },
    mounted: function() {
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '~@css/var.scss';

    .color-warning{color:$warningColor; font-weight:bold; margin-left:1em;}
</style>
